import { enIN } from 'date-fns/locale';
import { Field, Formik, Form as FormikForm } from 'formik';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { registerLocale } from 'react-datepicker';
import validAllowedCharacters from '../../../constants/valid-character-password';
import { TagsFilterInitialState } from '../../../core/initialState/filter-initial-state';
import { IUserFilter } from '../../../models/IUserFilter';
import FormikFormInput from '../../../shared-components/FormikFormHandlers/FormikFormInput';
import FormLoader from '../../../shared-components/FormLoader/FormLoader';
import Label from '../../../shared-components/label/label';
import { formatMessage } from '../../../translations/format-message';

registerLocale('en-IN', enIN);

interface IProps {
  initialValues: any;
  submitHandler: (data: any) => void;
  filterParmas: (data: any, isfilterCleard: boolean) => void;
  isLoading: boolean;
  isFilterCleared: boolean;
}

const FilterComponentNew = (props: IProps) => {
  return (
    <React.Fragment>
      <Formik
        initialValues={props.initialValues}
        enableReinitialize
        validateOnBlur={false}
        onSubmit={async (values: IUserFilter, { resetForm }) => {
          props.submitHandler(values);
        }}
      >
        {({ dirty, resetForm }) => (
          <FormikForm className="user-form pt-2 px-4">
            {props.isLoading && <FormLoader loading={props.isLoading} />}

            <Row>
              <Col md={3}>
                <div className="form-group mb-0">
                  <Label
                    className="label-style col-form-label"
                    required={false}
                    label="tray_id"
                    htmlFor="TrayId"
                  />
                  <Field
                    data-testid="TrayId"
                    className="form-control"
                    name="TrayId"
                    autoComplete="off"
                    placeholder=""
                    as={FormikFormInput}
                    validcharacter={validAllowedCharacters}
                  />
                </div>
              </Col>
              <Col md={3}>
                <div className="form-group mb-0">
                  <Label
                    className="label-style col-form-label"
                    required={false}
                    label="end_user_order_id_short"
                    htmlFor="EndUserId"
                  />
                  <Field
                    data-testid="EndUserId"
                    className="form-control"
                    name="EndUserId"
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    as={FormikFormInput}
                    validcharacter={validAllowedCharacters}
                  />
                </div>
              </Col>
              <Col md={3}>
                <div className="form-group mb-0">
                  <Label
                    className="label-style col-form-label"
                    required={false}
                    label="group"
                    htmlFor="Group"
                  />
                  <Field
                    data-testid="Group"
                    className="form-control"
                    name="Group"
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    as={FormikFormInput}
                    validcharacter={validAllowedCharacters}
                  />
                </div>
              </Col>

              <Col md={3}>
                <div className="d-flex justify-content-end  mt-4 clear-filter-btn ">
                  <Button
                    className="text-white"
                    onClick={() => {
                      props.filterParmas({ ...TagsFilterInitialState }, true);
                      resetForm();
                    }}
                  >
                    {formatMessage('clear_all_filters')}
                  </Button>
                  <Button
                    className="ms-3"
                    variant="secondary"
                    type="submit"
                  >
                    {formatMessage('search')}
                  </Button>
                </div>
              </Col>
            </Row>
          </FormikForm>
        )}
      </Formik>
    </React.Fragment>
  );
};

export default FilterComponentNew;
